<!-- 下拉 -->
<template>
  <div class="zlr-dropdowns">
    <img :src="userAvatar"
         alt="head sculpture"
         @click.stop="isShow=!isShow">
    <div v-show="isShow">
      <ul>
        <li>
          <a @click="linkHandle('undergraduate-personal')">Personal Info</a>
        </li>
        <!-- <li v-if="isPaymentInfo">
          <a @click="linkHandle('personal-payment')">Payment</a>
        </li>
        <li v-if="userRole">
          <a @click="linkHandle('apply-select')">Apply mentor</a>
        </li>-->
        <li>
          <a @click="linkHandle('choose-type')">Switch mentor type</a>
        </li>
        <li>
          <a @click="linkHandle('undergraduate-personal-modify-password')">Change password</a>
        </li>
        <li @click="logoutHandle">Log out</li>
      </ul>
    </div>
  </div>
</template>

<script>
// images
import logo from '@/assets/Logo.svg'
// less
import './dropdown.less'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'zlr-dropdown',
  components: {},
  data () {
    return {
      logo,
      isShow: false
    }
  },
  computed: {
    ...mapState({
      'isFillMore' (state) {
        return state.user.isFillMore
      },
      'isPaymentInfo' (sate) {
        return sate.user.isPaymentInfo
      },
      userAvatar (state) {
        let avatar = state.user.userAvatar ? state.user.userAvatar : 'https://res.zailairen.com/tech/msp/mentor-avatar.svg'

        return avatar
      },
      userRole (state) {
        return state.user.userRole
      }
    })
  },
  mounted () {
    let self = this
    document.body.addEventListener('click', function (event) {
      self.isShow = false
    })
  },
  methods: {
    ...mapActions(['handleLogOut']),
    logoutHandle () {
      this.handleLogOut().then(res => {
        this.$router.push({
          name: 'login'
        })
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    linkHandle (name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
